// Generated by LiveScript 1.6.0
var ref$, each, reject, register, unregisterElement, lookup, scanAndRegister, scanTree;
ref$ = require('./fn'), each = ref$.each, reject = ref$.reject;
register = function(reg, key, entry){
  var list;
  list = reg.get(key) || [];
  list.push(entry);
  return reg.set(key, list);
};
unregisterElement = function(reg, el){
  return reg.forEach(function(entries, key){
    var remaining;
    remaining = reject(function(it){
      return it.el === el;
    })(
    entries);
    if (remaining.length === 0) {
      return reg['delete'](key);
    } else if (remaining.length < entries.length) {
      return reg.set(key, remaining);
    }
  });
};
lookup = function(reg, key){
  return reg.get(key) || [];
};
scanAndRegister = function(reg, el, ctx){
  return ctx.directives.forEach(function(arg$, name){
    var isParametric, val, idx, key, param;
    isParametric = arg$.isParametric;
    if (val = el.getAttribute(ctx.prefix + "" + name)) {
      idx = val.indexOf(':');
      key = isParametric && idx > -1 ? val.substring(0, idx) : val;
      param = isParametric && idx > -1 ? val.slice(idx + 1) : void 8;
      if (!key.endsWith('.#')) {
        return register(reg, key, {
          el: el,
          directive: name,
          param: param
        });
      }
    }
  });
};
scanTree = function(reg, el, ctx){
  var children, i$, to$, i, results$ = [];
  scanAndRegister(reg, el, ctx);
  children = el.children;
  for (i$ = 0, to$ = children.length; i$ < to$; ++i$) {
    i = i$;
    results$.push(scanTree(reg, children[i], ctx));
  }
  return results$;
};
module.exports = {
  register: register,
  unregisterElement: unregisterElement,
  lookup: lookup,
  scanAndRegister: scanAndRegister,
  scanTree: scanTree
};